import axios from 'axios'

export const tagTreeCache = (data) => {
  return axios.request({
    method: "GET",
    url: '/api/directive/tagTreeCache',
    params: data,
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
  })
}

export const dataSearch = (data) => {
  return axios.request({
    method: "POST",
    url: '/cms/data/search',
    data: data,
    headers: { 'content-type': 'application/json' }
  })
}


export const Cmsdetail = (data) => {
  return axios.request({
    method: "POST",
    url: '/cms/detail',
    data: data,
    headers: { 'content-type': 'application/json' }
  })
}

export const cmsDataSearchFgbqTypeList = (data) => {
  return axios.request({
    method: "POST",
    url: '/cms/data/searchFgbqTypeList',
    data: data,
    headers: { 'content-type': 'application/json' }
  })
}


export const cmsDataSearchTagIsHave = (data) => {
  return axios.request({
    method: "POST",
    url: '/cms/data/searchTagIsHave',
    data: data,
    headers: { 'content-type': 'application/json' }
  })
}

export const cmsDataGetTag = (data) => {
  return axios.request({
      method: "post",
      url: '/cms/data/getTagNames',
      params: data,
      headers: { 'content-type': 'application/x-www-form-urlencoded' }
  })
}

export const getDaYiData = (data) => {
  return axios.request({
      method: "post",
      url: '/zsg/dayi/search',
      data: data,
      headers: { 'content-type': 'application/json' }
  })
}


export const cmsDataGetTagNames = (data) => {
  return axios.request({
    method: "GET",
    url: '/cms/data/getTagNames',
    params: data,
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
  })
}

export const cmsDictionaryDataList = (data) => {
  return axios.request({
    method: "GET",
    url: "/api/directive/dictionaryDataList",
    params: data,
    headers: { "content-type": "application/x-www-form-urlencoded" },
  });
};
// 查询一级 二级 三级 分类
export const categoryCategoryTree = (data) => {
  return axios.request({
    method: "POST",
    url: '/zsg/category/categoryTree',
    data: data,
    headers: { 'content-type': 'application/json' }
  })
}
// 列表查询
export const zsgSearch = (data) => {
  return axios.request({
    method: "POST",
    url: '/zsg/zsg/search',
    data: data,
    headers: { 'content-type': 'application/json' }
  })
}
export const zsgSearchFromData = (data) => {
  return axios.request({
    method: "POST",
    url: '/zsg/zsg/search',
    data: data,
    headers: { 'content-type': 'application/json' }
  })
}

// 登录
export const login = (data) => {
  return axios.request({
    method: "get",
    url: '/zsg/user/detail',
    params: data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 购买列表
export const orderList = (data) => {
  return axios.request({
    method: "POST",
    url: '/shopApi/order/list',
    params: data,
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
  })
}
